/*
 * Форматирование финансовых значений 000 000
 */
import moment from 'moment';

export function formatFinance(num) {
    return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') : '';
}
/*
 * Ищет по названию поля (field) в из значения в фильтре (filter) в списке (list) и ставит заголовок (names)
 */
export function getNames(list, field, names, filter) {
    if (Object.keys(list).length !== 0) {
        return `${names[field]} : ${filter[field].map(id => list.find(item => item.id === id).name).join(' | ')}; `;
    } else {
        return '';
    }
}
/*
 * Определение окончания слова в зависимости от числа
 */
export function declOfNum(n, titles) {
    const index = (n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
    return n + ' ' + titles[index];
}

export function formatText(text) {
    return text ? (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2') : '';
}

export function truncateText(text, maxLength) {
    if (!text) {
        return '';
    }
    const ending = '...';
    return text.length > maxLength ? text.substring(0, maxLength - ending.length) + ending : text;
}

export function formatDate(date) {
    return date ? moment(date).format('DD.MM.YYYY') : '';
}

export function timestampToDate(date) {
    return date ? moment(date * 1000).format('DD.MM.YYYY') : '';
}

export function formatDateTime(date) {
    return date ? moment(date).format('DD.MM.YYYY HH:mm') : '';
}

export function timestampToDateTime(date) {
    return date ? moment(date * 1000).format('DD.MM.YYYY HH:mm') : '';
}

export function viewCustomFields(customFields) {
    return customFields.reduce((fields, field) => fields + field.name + ':' + field.value + '; ', '');
}
